/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { integrationsList } from "../funcs/integrationsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListIntegrationsResult } from "../models/components/listintegrationsresult.js";
import {
  ListIntegrationsRequest,
  ListIntegrationsSecurity,
} from "../models/operations/listintegrations.js";
import { unwrapAsync } from "../types/fp.js";
export type ListIntegrationsQueryData = ListIntegrationsResult;

export function prefetchListIntegrations(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListIntegrationsRequest | undefined,
  security?: ListIntegrationsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListIntegrationsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListIntegrationsQuery(
  client$: GramCore,
  request?: ListIntegrationsRequest | undefined,
  security?: ListIntegrationsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListIntegrationsQueryData>;
} {
  return {
    queryKey: queryKeyListIntegrations({
      keywords: request?.keywords,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listIntegrationsQueryFn(
      ctx,
    ): Promise<ListIntegrationsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(integrationsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListIntegrations(
  parameters: {
    keywords?: Array<string> | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "integrations", "list", parameters];
}
